import React from 'react';
import { PopupBasic, User } from '../../../components';

const LikedByPopup = ({
  onClose = () => {},
  title,
  data = []
}) => {
  const finalTitle = title ? title : `Liked By: ${data.length} User(s)`

  return (
    <PopupBasic onClose={onClose} title={finalTitle}>
      {
        data && data.map(user => (
          <div className="mb-2">
            <User name={user.name} image={user.image}/>
          </div>
          // <Link to={`/profile/${user.id}`} className="block mb-2">
          //   <User name={user.name} image={user.image}/>
          // </Link>
        ))
      }
    </PopupBasic>
  )
}

export default LikedByPopup
